import { ApiConfig } from '@/config/ApiConfig'

const TOKEN_KEY = 'sss.access_token'

export class HttpError extends Error {
  constructor(public status: number, public payload: unknown, message: string) {
    super(message)
    this.name = 'HttpError'
  }
}

export const HttpClient = {
  setToken(token: string | null): void {
    if (token === null) localStorage.removeItem(TOKEN_KEY)
    else localStorage.setItem(TOKEN_KEY, token)
  },

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY)
  },

  newRequestId(): string {
    // Sufficient for idempotency dedup; not crypto-grade.
    const rand = Math.random().toString(36).slice(2, 10)
    return `req_${Date.now().toString(36)}_${rand}`
  },

  async request<T>(method: 'GET' | 'POST', path: string, body?: unknown): Promise<T> {
    const url = `${ApiConfig.apiBase}${path}`
    const headers: Record<string, string> = { 'content-type': 'application/json' }
    const token = this.getToken()
    if (token) headers['authorization'] = `Bearer ${token}`

    const init: RequestInit = { method, headers }
    if (body !== undefined) init.body = JSON.stringify(body)

    const res = await fetch(url, init)
    const text = await res.text()
    let payload: unknown = null
    try {
      payload = text.length > 0 ? JSON.parse(text) : null
    } catch {
      payload = text
    }
    if (!res.ok) {
      throw new HttpError(res.status, payload, `${method} ${path} → ${res.status}`)
    }
    return payload as T
  },

  get<T>(path: string): Promise<T> {
    return this.request<T>('GET', path)
  },

  post<T>(path: string, body: unknown): Promise<T> {
    return this.request<T>('POST', path, body)
  },
}
